export default {"src":"/_next/static/media/events.dee7c02c.svg","height":22,"width":22};